import React from "react";
import { useStyles } from "./FullScreenButton.styles";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { IFullScreenButtonProps } from "./FullScreenButtonInterfaces";
import { useTranslation } from "react-i18next";

export const FullScreenButton = ({ isFullscreenActive, handleSetIsFullscreenActive }: IFullScreenButtonProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.headerActionWrapper} onClick={() => handleSetIsFullscreenActive(!isFullscreenActive)}>
            {isFullscreenActive ? <FullscreenExitIcon /> : <FullscreenIcon />}
            {isFullscreenActive
                ? t("locations.mill_dashboards.exit_fullscreen")
                : t("locations.mill_dashboards.fullscreen")}
        </div>
    );
};
